<template>
  <v-form
    ref="form"
    lazy-validation
    v-model="valid"
    class="d-grid grid-col-lg-1-1 gap-5 align-start"
    :class="(designAndCustomerData.street || designAndCustomerData.zip || designAndCustomerData.city)
    ? 'grid-col-xxl-3-2'
    : 'grid-col-xxl-2-2'"
    
  >
    <div
     class="d-grid gap-5 align-start"
     :class="(designAndCustomerData.street || designAndCustomerData.zip || designAndCustomerData.city)
     ? 'grid-col-xxl-2-1' : edit ? 'grid-col-xxl-2-1' : 'grid-col-xxl-1'"
    >
      <BaseCard
        :title="t['project_client-sections']['proektnye-dannye']"
        class-body="d-grid grid-col-md-1-1 gap-8"
      >
        <div class="d-grid gap-8">
          <BaseInput
            :label="t['project_client-labels']['nazvanie-proekta']"
            :placeholder="t['project_client-inputs']['obekt-1']"
            v-model="designAndCustomerData.name"
            :view="!edit"
            :rules="['required', 'max100']"
            copy
            :error-message="
              error.name
                ? localStorage.translations.pages.common.notifications['name_is_already_in_use']
                : ''
            "
            @input="error.name = false"
          />
          <BaseInput
            :label="t['project_client-labels']['nomer-proekta']"
            :view-value="
              workClientProjectShow && workClientProjectShow.id == $route.params.id
                ? $clientProjectNumber({
                    project_id: workClientProjectShow.id,
                    year: workClientProjectShow.year,
                    segment_letter: segmentLetter,
                  })
                : $clientProjectNumber({})
            "
            view
          />
          <BaseInput
            :label="t['project_client-labels']['segment-vida-deyatelnosti']"
            :label-second="t['project_client-labels']['dobavte-i-ili-vyberite-iz-spiska']"
            v-model="designAndCustomerData.business_segment_id"
            :view-value="
              findItemData(businessSegmentAll, designAndCustomerData.business_segment_id)
            "
            type="autocomplete"
            :items="businessSegmentAll"
            :view="!edit"
            prepend-inner-icon="search"
            :rules="['required']"
          >
            <BusinessSegmentModal create minimalize />
          </BaseInput>
          <BaseInput
            :label="t['project_client-labels']['tip-proekta']"
            :label-second="t['project_client-labels']['dobavte-i-ili-vyberite-iz-spiska']"
            v-model="designAndCustomerData.project_type_id"
            :view-value="findItemData(workProjectTypeAll, designAndCustomerData.project_type_id)"
            type="autocomplete"
            :items="workProjectTypeAllSegment"
            :rules="['required']"
            :view="!edit"
            :disabled="
              !designAndCustomerData.business_segment_id ||
              (designAndCustomerData.business_segment_id && !workProjectTypeAllSegment.length)
            "
            :tooltip="
              t['project_client-tooltips'][
                designAndCustomerData.business_segment_id
                  ? 'dobavte-tip-proekta'
                  : 'vyberite-segment-vida-deyatelnosti'
              ]
            "
            :tooltip-disabled="
              !!(designAndCustomerData.business_segment_id && workProjectTypeAllSegment.length)
            "
            prepend-inner-icon="search"
          >
            <ProjectTypeModal
              v-if="designAndCustomerData.business_segment_id"
              create
              minimalize
              :segmentId="designAndCustomerData.business_segment_id"
            />
          </BaseInput>
        </div>
        <div class="d-grid gap-8">
          <BaseInput
            :label="localStorage.translations.pages.common.text['project_id'] || 'Project ID'"
            v-model="designAndCustomerData.internal_project_id"
            :view="!edit"
            :view-value="designAndCustomerData?.internal_project_id || ''"
          />
          <BaseInput
            :label="t['project_client-labels']['predpolagaemaya-data-nachala-proekta']"
            v-model="designAndCustomerData.start_date"
            type="date-picker"
            :placeholder="t['project_client-inputs']['ne-vybrano']"
            :view="!edit"
            :view-value="$formatDate(designAndCustomerData.start_date)"
            :rules="['required']"
          />
          <BaseInput
            :label="t['project_client-labels']['predpolagaemaya-data-okonchaniya-proekta']"
            v-model="designAndCustomerData.end_date"
            type="date-picker"
            :placeholder="t['project_client-inputs']['ne-vybrano']"
            :disabled="!designAndCustomerData.start_date"
            :show-current="
              designAndCustomerData[designAndCustomerData.end_date ? 'end_date' : 'start_date']
            "
            :view="!edit"
            :view-value="$formatDate(designAndCustomerData.end_date)"
            :rules="['required']"
            :date-min="
              designAndCustomerData.start_date
                ? designAndCustomerData.start_date
                : new Date().toISOString().slice(0, 10)
            "
            :tooltip="t['project_client-tooltips']['vyberite-datu-nachala']"
            :tooltip-disabled="!!designAndCustomerData.start_date"
          />
          <BaseInput
            :label="t['project_client-labels']['primechanie']"
            v-model="designAndCustomerData.notes"
            type="textarea"
            :view="!edit"
            rows="5"
          />
        </div>
      </BaseCard>
      <BaseCard
       v-if="edit ? edit : (designAndCustomerData.street || designAndCustomerData.zip || designAndCustomerData.city)"
        :title="t['project_client-sections']['adres-obekta']"
        :max-width="$vuetify.breakpoint.width > 2500 ? null : 700"
      >
        <GoogleAutocomplete
          v-if="edit"
          :street="designAndCustomerData.street"
          :zip="designAndCustomerData.zip"
          :city="designAndCustomerData.city"
          :on-change="changeAddress"
          :required='false'
        />
        <BaseLink
         v-if="designAndCustomerData.street || designAndCustomerData.zip || designAndCustomerData.city"
          :text="
          (designAndCustomerData.street ? designAndCustomerData.street : '') +
          (designAndCustomerData.zip ? ', ' + designAndCustomerData.zip : '') +
          (designAndCustomerData.city ? ', ' + designAndCustomerData.city: '')
          "
          type="map"
          copy
        />
      </BaseCard>
    </div>
    <BaseCard
      :title="t['project_client-sections']['klientskie-dannye']"
      class-body="d-grid grid-col-md-1-1 gap-8 align-start"
    >
      <div class="d-grid gap-8">
        <BaseInput
          :label="t['project_client-labels']['nomer-obekta-klienta']"
          v-model="designAndCustomerData.client_project_number"
          :view="!edit"
          :view-value="designAndCustomerData?.client_project_number || '—'"
          placeholder="132513454363"
          :rules="['max50']"
        />
        <BaseInput
          :label="t['project_client-labels']['klient']"
          :label-second="t['project_client-labels']['dobavte-i-ili-vyberite-iz-spiska']"
          v-model="designAndCustomerData.work_client_id"
          :items="workClientAll"
          :rules="['required']"
          type="autocomplete"
          prepend-inner-icon="search"
          :view="!edit || !$userCheckAccess({ abilities: 'view_clients' })"
          :view-value="
            (workClientProjectShow &&
              workClientProjectShow.work_client &&
              workClientProjectShow.work_client.name) ||
            '—'
          "
        >
          <WorkClientModal create minimalize />
        </BaseInput>
        <BaseInput
          :label="t['project_client-labels']['otvetstvennoe-litso-po-kontraktu']"
          :label-second="t['project_client-labels']['dobavte-i-ili-vyberite-iz-spiska']"
          v-model="designAndCustomerData.responsible_client_person_id"
          :items="workClientPersonAllClient"
          :item-text="
            (item) =>
              item.first_name +
              ' ' +
              item.last_name +
              (item.position ? ', ' + item.position : '') +
              (item.phone ? ', ' + item.phone : '') +
              (item.email ? ', ' + item.email : '')
          "
          type="autocomplete"
          :disabled="
            !!(
              (!designAndCustomerData.work_client_id && !workClientPersonAllClient.length) ||
              (!designAndCustomerData.work_client_id && workClientPersonAllClient.length) ||
              (designAndCustomerData.work_client_id && !workClientPersonAllClient.length)
            )
          "
          prepend-inner-icon="search"
          :tooltip="
            t['project_client-tooltips'][
              designAndCustomerData.work_client_id ? 'dobavte-kontaktnoe-litso' : 'vyberite-klienta'
            ]
          "
          :tooltip-disabled="
            !!(designAndCustomerData.work_client_id && workClientPersonAllClient.length)
          "
          :view="!edit"
        >
          <template v-slot:viewValue>
            <div class="f14">
              <template
                v-if="
                  findItem(
                    workClientPersonAllClient,
                    designAndCustomerData.responsible_client_person_id,
                  )
                "
              >
                <div>
                  {{
                    findItem(
                      workClientPersonAllClient,
                      designAndCustomerData.responsible_client_person_id,
                    ).first_name +
                    ' ' +
                    findItem(
                      workClientPersonAllClient,
                      designAndCustomerData.responsible_client_person_id,
                    ).last_name +
                    (findItem(
                      workClientPersonAllClient,
                      designAndCustomerData.responsible_client_person_id,
                    ).position
                      ? ', ' +
                        findItem(
                          workClientPersonAllClient,
                          designAndCustomerData.responsible_client_person_id,
                        ).position
                      : '')
                  }}
                </div>
                <BaseLink
                  v-if="
                    findItem(
                      workClientPersonAllClient,
                      designAndCustomerData.responsible_client_person_id,
                    ).phone
                  "
                  :text="
                    findItem(
                      workClientPersonAllClient,
                      designAndCustomerData.responsible_client_person_id,
                    ).phone
                  "
                  type="tel"
                  copy
                  class="py-1"
                />
                <BaseLink
                  v-if="
                    findItem(
                      workClientPersonAllClient,
                      designAndCustomerData.responsible_client_person_id,
                    ).email
                  "
                  :text="
                    findItem(
                      workClientPersonAllClient,
                      designAndCustomerData.responsible_client_person_id,
                    ).email
                  "
                  type="mail"
                  copy
                />
              </template>
              <template v-else> —</template>
            </div>
          </template>
          <WorkClientPersonModal
            v-if="
              designAndCustomerData.work_client_id &&
              $userCheckAccess({ abilities: 'view_client_people' })
            "
            create
            minimalize
            :clientId="designAndCustomerData.work_client_id"
          />
        </BaseInput>
        <BaseInput
          :label="t['project_client-labels']['kontaktnoe-litso']"
          :label-second="t['project_client-labels']['dobavte-i-ili-vyberite-iz-spiska']"
          v-model="designAndCustomerData.contact_client_person_id"
          type="autocomplete"
          :items="workClientPersonAllClient"
          :disabled="
            !!(
              (!designAndCustomerData.work_client_id && !workClientPersonAllClient.length) ||
              (!designAndCustomerData.work_client_id && workClientPersonAllClient.length) ||
              (designAndCustomerData.work_client_id && !workClientPersonAllClient.length)
            )
          "
          prepend-inner-icon="search"
          :item-text="
            (item) =>
              item.first_name +
              ' ' +
              item.last_name +
              (item.position ? ', ' + item.position : '') +
              (item.phone ? ', ' + item.phone : '') +
              (item.email ? ', ' + item.email : '')
          "
          :tooltip="
            t['project_client-tooltips'][
              designAndCustomerData.work_client_id ? 'dobavte-kontaktnoe-litso' : 'vyberite-klienta'
            ]
          "
          :tooltip-disabled="
            !!(designAndCustomerData.work_client_id && workClientPersonAllClient.length)
          "
          :view="!edit"
          :view-value="
            findItemData(workClientPersonAllClient, designAndCustomerData.contact_client_person_id)
          "
        >
          <template v-slot:viewValue>
            <div class="f14">
              <template
                v-if="
                  findItem(
                    workClientPersonAllClient,
                    designAndCustomerData.contact_client_person_id,
                  )
                "
              >
                <div>
                  {{
                    findItem(
                      workClientPersonAllClient,
                      designAndCustomerData.contact_client_person_id,
                    ).first_name +
                    ' ' +
                    findItem(
                      workClientPersonAllClient,
                      designAndCustomerData.contact_client_person_id,
                    ).last_name +
                    (findItem(
                      workClientPersonAllClient,
                      designAndCustomerData.contact_client_person_id,
                    ).position
                      ? ', ' +
                        findItem(
                          workClientPersonAllClient,
                          designAndCustomerData.contact_client_person_id,
                        ).position
                      : '')
                  }}
                </div>
                <BaseLink
                  v-if="
                    findItem(
                      workClientPersonAllClient,
                      designAndCustomerData.contact_client_person_id,
                    ).phone
                  "
                  :text="
                    findItem(
                      workClientPersonAllClient,
                      designAndCustomerData.contact_client_person_id,
                    ).phone
                  "
                  type="tel"
                  copy
                  class="py-1"
                />
                <BaseLink
                  v-if="
                    findItem(
                      workClientPersonAllClient,
                      designAndCustomerData.contact_client_person_id,
                    ).email
                  "
                  :text="
                    findItem(
                      workClientPersonAllClient,
                      designAndCustomerData.contact_client_person_id,
                    ).email
                  "
                  type="mail"
                  copy
                />
              </template>
              <template v-else> —</template>
            </div>
          </template>
          <WorkClientPersonModal
            v-if="
              designAndCustomerData.work_client_id &&
              $userCheckAccess({ abilities: 'view_client_people' })
            "
            create
            minimalize
            :clientId="designAndCustomerData.work_client_id"
          />
        </BaseInput>
        <BaseInput
          :label="t['project_client-labels']['region']"
          :label-second="t['project_client-labels']['dobavte-i-ili-vyberite-iz-spiska']"
          v-model="designAndCustomerData.region_id"
          :items="workRegionAll"
          type="autocomplete"
          :view="!edit"
          :view-value="findItemData(workRegionAll, designAndCustomerData.region_id)"
        >
          <WorkRegionModal create minimalize />
        </BaseInput>
        <BaseInput
          :label="t['project_client-labels']['company-sale']"
          :label-second="t['project_client-labels']['dobavte-i-ili-vyberite-iz-spiska']"
          v-model="designAndCustomerData['invoicing_company']"
          :items="workClientInvoicingCompanyAll"
          type="autocomplete"
          :disabled="
            !!(
              (!designAndCustomerData.work_client_id && !workClientPersonAllClient.length) ||
              (!designAndCustomerData.work_client_id && workClientPersonAllClient.length) ||
              (designAndCustomerData.work_client_id && !workClientPersonAllClient.length)
            )
          "
          prepend-inner-icon="search"
          :view="!edit"
          :view-value="
            designAndCustomerData['invoicing_company']
              ? designAndCustomerData['invoicing_company'].name
              : '—'
          "
        >
          <WorkClientModal create minimalize company-sale />
        </BaseInput>
      </div>
      <div class="d-grid gap-8">
        <div
          v-if="edit || designAndCustomerData.images || designAndCustomerData.projectPhotoBase64"
        >
          <ImageFullModal
            v-if="designAndCustomerData.images || designAndCustomerData.projectPhotoBase64"
            :editing="false"
            :minImg="
              !designAndCustomerData.projectPhotoBase64
                ? apiDomain + '/min/' + designAndCustomerData.images
                : designAndCustomerData.projectPhotoBase64
            "
            :maxImg="
              !designAndCustomerData.projectPhotoBase64
                ? apiDomain + '/' + designAndCustomerData.images
                : designAndCustomerData.projectPhotoBase64
            "
            :avatar="true"
            :minContain="true"
            max-width="600"
            max-height="400"
            position="left"
          />
          <ButtonImageAdd
            v-if="edit"
            @buttonImageData="onButtonImageData"
            :text="
              t['project_client-buttons'][
                projectPhoto ? 'obnovit-foto-proekta' : 'zagruzit-foto-proekta'
              ]
            "
            class="mt-3"
          />
        </div>
        <div v-else class="secondary lighten-5">
          <v-img
            :src="require('~/assets/svg/ImageNotFound.svg')"
            max-width="150"
            max-height="150"
            class="mx-auto"
          />
        </div>
        <BaseInput
          :label="t['project_client-labels']['filial']"
          :label-second="t['project_client-labels']['dobavte-i-ili-vyberite-iz-spiska']"
          v-model="designAndCustomerData.work_client_office_id"
          :items="workClientOfficesAll"
          item-value="id"
          item-text="name"
          type="autocomplete"
          :disabled="
            !!(
              (!designAndCustomerData.work_client_id && !workClientOfficesAll.length) ||
              (!designAndCustomerData.work_client_id && workClientOfficesAll.length)
            )
          "
          prepend-inner-icon="search"
          :tooltip="
            t['project_client-tooltips'][
              designAndCustomerData.work_client_id ? 'dobavte-filial' : 'vyberite-klienta'
            ]
          "
          :tooltip-disabled="!!designAndCustomerData.work_client_id && !!workClientOfficesAll"
          :view="!edit"
          :view-value="
            findItemData(workClientOfficesAll, designAndCustomerData.work_client_office_id)
          "
        >
          <WorkClientOfficesModal
            v-if="
              designAndCustomerData.work_client_id &&
              $userCheckAccess({ abilities: 'edit_client_addresses' })
            "
            create
            minimalize
            :clientId="designAndCustomerData.work_client_id"
          />
        </BaseInput>
        <BaseInput
          :label="t['project_client-labels']['primechanie']"
          v-model="designAndCustomerData.client_notes"
          type="textarea"
          :view="!edit"
          rows="5"
        />
      </div>
    </BaseCard>
    <BaseCard :title="blocksTitle" class="blocks-card" class-body="d-grid gap-5">
      <template v-if="edit">
        <div v-if="designAndCustomerData.blocks.length" class="d-grid gap-3">
          <div
            v-for="(block, index) in designAndCustomerData.blocks"
            :key="`block-${index}`"
            class="d-grid gap-2"
          >
            <div class="d-flex align-center gap-2">
              <v-text-field
                v-model="designAndCustomerData.blocks[index]"
                :label="`${blockLabel} ${index + 1}`"
                dense
                outlined
                hide-details
                class="flex-grow-1"
              />
              <v-btn icon color="error" @click="removeBlock(index)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </div>
          </div>
        </div>
        <div v-else class="secondary--text f14">—</div>
        <BaseButton
          @click="addBlock"
          :text="addBlockText"
          default_icon="button-plus"
          class="justify-self-start"
        />
      </template>
      <template v-else>
        <div v-if="normalizedBlocks.length" class="d-grid gap-2 f14">
          <div v-for="(block, index) in normalizedBlocks" :key="`block-view-${index}`">
            {{ block }}
          </div>
        </div>
        <div v-else class="secondary--text f14">—</div>
      </template>
    </BaseCard>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BusinessSegmentModal from 'components/setting/businessSegment/BusinessSegmentModal'
import ProjectTypeModal from 'components/setting/projectType/ProjectTypeModal'
import GoogleAutocomplete from 'components/google/autocomplete/GoogleAutocomplete'
import WorkClientModal from 'components/workClient/WorkClientModal'
import WorkClientPersonModal from 'components/workClient/person/WorkClientPersonModal'
import WorkRegionModal from 'components/setting/workRegion/WorkRegionModal'
import ImageFullModal from 'components/ImageFullModal'
import ButtonImageAdd from 'components/ButtonImageAdd'
import WorkClientOfficesModal from 'components/workClient/offices/WorkClientOfficesModal'

export default {
  name: 'ProjectDesignAndCustomer',
  props: ['edit', 'createContinue'],
  components: {
    WorkClientOfficesModal,
    ButtonImageAdd,
    ImageFullModal,
    WorkRegionModal,
    WorkClientPersonModal,
    WorkClientModal,
    GoogleAutocomplete,
    BusinessSegmentModal,
    ProjectTypeModal,
  },
  data() {
    return {
      error: {
        name: false,
      },
      valid: false,
      menu1: false,
      menu2: false,
      projectPhoto: null,
      clientProjectPhoto: null,
      projectTypeInSegment: [],
      designAndCustomerData: {
        work_client_id: null,
        name: '',
        client_project_number: '',
        internal_project_id: null,
        responsible_client_person_id: null,
        contact_client_person_id: null,
        work_client_office_id: null,
        business_segment_id: null,
        project_type_id: null,
        region_id: null,
        start_date: null,
        end_date: null,
        city: '',
        zip: '',
        street: '',
        images: null,
        notes: '',
        client_notes: '',
        projectPhotoBase64: null,
        invoicing_company: null,
        blocks: [],
      },
      loadingData: false,
    }
  },
  created() {
    if (this.pageSalesProjectCreate) {
      this.onCheckChange({ overwrite: true })
    }
    this.onDownloadData({})
  },
  watch: {
    edit() {
      this.designAndCustomerData.projectPhotoBase64 = null
      if (this.edit) {
        this.onCheckChange({ overwrite: true })
      } else {
        this.onDownloadData({ update: true })
      }
    },
    'designAndCustomerData.business_segment_id'() {
      this.onWorkProjectTypeAllSegment(this.designAndCustomerData.business_segment_id)
    },
    workProjectTypeAll() {
      if (this.designAndCustomerData.business_segment_id) {
        this.filterProjectTypeInSegment(this.designAndCustomerData.business_segment_id)
      }
    },
    'designAndCustomerData.work_client_id': {
      deep: true,
      handler(newVal, oldVal) {
        if (oldVal !== null) {
          this.designAndCustomerData.responsible_client_person_id = null
          this.designAndCustomerData.contact_client_person_id = null
        }
        this.onWorkClientPersonAllClient(this.designAndCustomerData.work_client_id)
        this.onWorkClientOfficesAll(this.designAndCustomerData.work_client_id)
      },
    },
    designAndCustomerData: {
      deep: true,
      handler() {
        if (this.edit) {
          this.onCheckChange({ overwrite: false })
        }
      },
    },
  },
  mounted() {},
  computed: {
    ...mapGetters(['inputRules']),
    ...mapGetters('workClientProject', ['workClientProjectAmount', 'workClientProjectShow']),
    ...mapGetters('workBusinessSegment', ['businessSegmentAll']),
    ...mapGetters('workProjectType', ['workProjectTypeAllSegment', 'workProjectTypeAll']),
    ...mapGetters('workClient', ['workClientAll']),
    ...mapGetters('workClientInvoicingCompany', ['workClientInvoicingCompanyAll']),
    ...mapGetters('workRegion', ['workRegionAll']),
    ...mapGetters('workClientOffices', ['workClientOfficesAll']),
    ...mapGetters('workClientPerson', ['workClientPersonAllClient']),
    t() {
      return this.localStorage.translations.pages['sales_project']
    },
    blocksTitle() {
      return this.localStorage.translations.pages.common.text['blocks'] || 'Blocks'
    },
    blockLabel() {
      return this.localStorage.translations.pages.common.text['block'] || 'Block'
    },
    addBlockText() {
      return this.t?.['project_client-buttons']?.['dobavit-blok'] || 'Add block'
    },
    normalizedBlocks() {
      return this.normalizeBlocks(this.designAndCustomerData.blocks)
    },
    allDataReady() {
      return this.designAndCustomerData.name !== null
    },
    apiDomain() {
      return this.$store.state.apiDomain
    },
    pageSalesProjectCreate() {
      return this.$route.name === 'SalesProjectCreate'
    },
    segmentLetter() {
      let result = null
      if (
        this.businessSegmentAll.length &&
        this.workClientProjectShow &&
        this.workClientProjectShow.business_segment_id
      ) {
        result = this.businessSegmentAll
          .find((i) => i.id === this.workClientProjectShow.business_segment_id)
          .name.substr(0, 1)
      }
      return result
    },
  },
  methods: {
    ...mapActions('workClientProject', [
      'onWorkClientProjectAmount',
      'onWorkClientProjectShow',
      'onWorkClientProjectCreate',
      'onWorkClientProjectUpdate',
    ]),
    ...mapActions('workBusinessSegment', ['onBusinessSegmentAll']),
    ...mapActions('workProjectType', ['onWorkProjectTypeAllSegment', 'onWorkProjectTypeAll']),
    ...mapActions('workClient', ['onWorkClientAll']),
    ...mapActions('workClientInvoicingCompany', ['onWorkClientInvoicingCompanyAll']),
    ...mapActions('workRegion', ['onWorkRegionAll']),
    ...mapActions('workClientOffices', ['onWorkClientOfficesAll']),
    ...mapActions('workClientPerson', ['onWorkClientPersonAllClient']),
    ...mapActions('navigationGuardian', ['onNavigationGuardianCheck']),
    onDownloadData({ projectId, update }) {
      this.loadingData = true
      const projectQuerie = !this.pageSalesProjectCreate
        ? this.onWorkClientProjectShow(projectId || this.$route.params.id).then(() => {
            this.onActualData()
          })
        : true
      let queries = [projectQuerie]
      if (!update) {
        const basicQueries = [
          this.onBusinessSegmentAll(),
          this.onWorkProjectTypeAll(),
          this.$userCheckAccess({
            abilities: 'view_clients',
          })
            ? this.onWorkClientAll()
            : true,
          this.$userCheckAccess({
            abilities: 'view_clients',
          })
            ? this.onWorkClientInvoicingCompanyAll()
            : true,
          this.onWorkRegionAll(),
          this.onWorkClientProjectAmount(),
        ]
        queries.push(...basicQueries)
      }
      let result = Promise.all(queries).then(() => (this.loadingData = false))
      return result
    },
    onCheckChange({ overwrite }) {
      this.onNavigationGuardianCheck({
        data: { designAndCustomerData: this.designAndCustomerData },
        overwrite,
      })
    },
    onActualData() {
      if (!this.pageSalesProjectCreate) {
        this.designAndCustomerData.name = this.workClientProjectShow.name
        this.designAndCustomerData.business_segment_id =
          this.workClientProjectShow.business_segment_id
        this.designAndCustomerData.client_project_number =
          this.workClientProjectShow.client_project_number
        this.designAndCustomerData.internal_project_id = this.workClientProjectShow.internal_project_id
        if (this.workClientProjectShow.work_client) {
          this.designAndCustomerData.work_client_id = this.workClientProjectShow.work_client.id
          this.designAndCustomerData.work_client_office_id =
            this.workClientProjectShow.work_client_office_id
        }
        this.designAndCustomerData.responsible_client_person_id =
          this.workClientProjectShow.responsible_client_person_id
        this.designAndCustomerData.contact_client_person_id =
          this.workClientProjectShow.contact_client_person_id
        this.designAndCustomerData.project_type_id = this.workClientProjectShow.project_type_id
        this.designAndCustomerData.start_date = this.workClientProjectShow.start_date
        this.designAndCustomerData.region_id = this.workClientProjectShow.region_id
        this.designAndCustomerData.end_date = this.workClientProjectShow.end_date
        this.designAndCustomerData.city = this.workClientProjectShow.city
        this.designAndCustomerData.zip = this.workClientProjectShow.zip
        this.designAndCustomerData.street = this.workClientProjectShow.street
        this.designAndCustomerData.images = this.workClientProjectShow.images
        this.designAndCustomerData.notes = this.workClientProjectShow.notes
        this.designAndCustomerData.client_notes = this.workClientProjectShow.client_notes
        this.designAndCustomerData.invoicing_company = this.workClientProjectShow.invoicing_company
        this.designAndCustomerData.blocks = Array.isArray(this.workClientProjectShow.blocks)
          ? this.workClientProjectShow.blocks.map((block) => String(block))
          : []
        if (this.edit) {
          this.onCheckChange({ overwrite: true })
        }
      }
    },
    findItemData(array, itemId) {
      if (array.length && itemId) {
        let data = array.find((i) => i.id === itemId)
        if (data !== undefined) {
          if (array === this.workClientPersonAllClient) {
            return data.first_name + ' ' + data.last_name + ', ' + data.phone + ', ' + data.position
          } else {
            return data.name
          }
        } else {
          return '—'
        }
      } else {
        return '—'
      }
    },
    findItem(array, itemId) {
      if (array.length && itemId) {
        let data = array.find((i) => i.id === itemId)
        if (data !== undefined) {
          return data
        } else {
          return null
        }
      } else {
        return null
      }
    },
    filterProjectTypeInSegment(segmentId) {
      return (this.projectTypeInSegment = this.workProjectTypeAll.filter(function (o) {
        if (o.segments.length) {
          return o.segments.filter((i) => i.id === segmentId).length
        }
      }))
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    onButtonImageData(data) {
      this.designAndCustomerData.projectPhotoBase64 = data.base64
      this.projectPhoto = data.file
    },
    validate() {
      return this.$refs.form.validate()
    },
    onCreateOrUpdate() {
      return new Promise(async (resolve, reject) => {
        if (this.validate()) {
          this.loadingData = true
          let data = {
            id:
              this.createContinue || !this.pageSalesProjectCreate
                ? this.workClientProjectShow.id
                : null,
            work_client_id: this.designAndCustomerData.work_client_id,
            name: this.designAndCustomerData.name,
            business_segment_id: this.designAndCustomerData.business_segment_id,
            end_date: this.designAndCustomerData.end_date,
            project_type_id: this.designAndCustomerData.project_type_id,
            start_date: this.designAndCustomerData.start_date,
            blocks: this.normalizeBlocks(this.designAndCustomerData.blocks),
          }
          if (this.$checkNavigationGuardianChange('designAndCustomerData')) {
            if (this.designAndCustomerData.projectPhotoBase64) {
              if (this.designAndCustomerData.images) {
                this.$store.dispatch('deleteFile', {
                  url: this.designAndCustomerData.images,
                })
              }
              await this.submitFile()
            }
            let data2 = {
              client_project_number: this.designAndCustomerData.client_project_number,
              internal_project_id: this.designAndCustomerData.internal_project_id || null,
              responsible_client_person_id: this.designAndCustomerData.responsible_client_person_id,
              contact_client_person_id: this.designAndCustomerData.contact_client_person_id,
              work_client_office_id: this.designAndCustomerData.work_client_office_id,
              business_segment_id: this.designAndCustomerData.business_segment_id,
              project_type_id: this.designAndCustomerData.project_type_id,
              region_id: this.designAndCustomerData.region_id,
              start_date: this.designAndCustomerData.start_date,
              end_date: this.designAndCustomerData.end_date,
              city: this.designAndCustomerData.city,
              zip: this.designAndCustomerData.zip,
              street: this.designAndCustomerData.street,
              images: this.designAndCustomerData.images,
              notes: this.designAndCustomerData.notes,
              client_notes: this.designAndCustomerData.client_notes,
              invoicing_company_id:
                this.designAndCustomerData.invoicing_company &&
                this.designAndCustomerData.invoicing_company.id
                  ? this.designAndCustomerData.invoicing_company.id
                  : this.designAndCustomerData.invoicing_company,
              blocks: this.normalizeBlocks(this.designAndCustomerData.blocks),
            }
            data = { ...data, ...data2 }
            if (this.createContinue === false) {
              this.onWorkClientProjectCreate(data)
                .then(async (response) => {
                  await this.onCheckChange({ overwrite: true })
                  this.$store.dispatch(
                    'popup/onMessage',
                    {
                      message:
                        this.localStorage.translations.pages.common.notifications[
                          'uspeshno-dobavlen'
                        ],
                      IsError: false,
                    },

                    { root: true },
                  )
                  this.loadingData = false
                  resolve(response.data.data.id)
                })
                .catch((error) => {
                  if (error.response.data.name[0]) {
                    this.$store.dispatch(
                      'popup/onMessage',
                      {
                        message:
                          this.localStorage.translations.pages.common.notifications[
                            'name_is_already_in_use'
                          ],
                        IsError: true,
                      },

                      { root: true },
                    )
                    this.error.name = true
                  } else
                    this.$store.dispatch(
                      'popup/onMessage',
                      {
                        message:
                          this.localStorage.translations.pages.common.notifications['oshibka'],
                        IsError: true,
                      },

                      { root: true },
                    )
                  this.loadingData = false
                  reject(false)
                })
            } else {
              if (this.createContinue) {
                this.onWorkClientProjectUpdate(data)
                  .then((response) => {
                    this.onCheckChange({ overwrite: true })
                    this.$store.dispatch(
                      'popup/onMessage',
                      {
                        message:
                          this.localStorage.translations.pages.common.notifications[
                            'izmeneniya-uspeshno-sohraneny'
                          ],
                        IsError: false,
                      },
                      { root: true },
                    )
                    this.loadingData = false
                    resolve(response)
                  })
                  .catch((err) => {
                    this.loadingData = false
                    reject(false)
                  })
              } else {
                this.loadingData = false
                resolve(data)
              }
            }
          } else {
            this.loadingData = false
            resolve(data)
          }
        } else {
          this.$store.dispatch(
            'popup/onMessage',
            {
              message:
                this.localStorage.translations.pages.common.notifications[
                  'fill_in_required_fields'
                ],
              IsError: true,
            },

            { root: true },
          )
          reject(false)
        }
      })
    },
    async submitFile() {
      let formData = new FormData()
      formData.append('file', this.projectPhoto)
      await this.$store
        .dispatch('uploadFile', { data: formData, use_case: 'cover' })
        .then((response) => {
          this.designAndCustomerData.images = response.data.url
        })
        .catch()
    },
    changeAddress(data) {
      this.designAndCustomerData.street = data.street
      this.designAndCustomerData.zip = data.zip
      this.designAndCustomerData.city = data.city
    },
    addBlock() {
      this.designAndCustomerData.blocks.push('')
    },
    removeBlock(index) {
      this.designAndCustomerData.blocks.splice(index, 1)
    },
    normalizeBlocks(blocks) {
      if (!Array.isArray(blocks)) {
        return []
      }
      return blocks
        .map((block) => (block === null || block === undefined ? '' : String(block).trim()))
        .filter((block) => !!block)
    },
  },
}
</script>

<style scoped lang="scss">
.blocks-card {
  grid-column: 1 / -1;
}
</style>
